import { Icon, Spin, Tabs } from 'antd';
import React from 'react';
import { useFetchWebsiteIndexEntriesQuery, useFetchFaviconsQuery } from './service';
import useGetCurrentWebsite from './hooks/useGetCurrentWebsite';
import WebsiteTab from './WebsiteTab';
import AddNewWebsiteIndexEntryButton from '../websiteIndexEntry/addNewWebsite/AddNewWebsiteIndexEntryButton';
import NoWebsites from './NoWebsites';
import "./WebsiteIndexEntryTabs.less";

const { TabPane } = Tabs;

type Props = {
    children: React.ReactNode;
    rightSideExtra?: React.ReactNode;
    destroyInactiveTabs?: boolean;
};

export default function WebsiteIndexEntryTabs({ children, rightSideExtra, destroyInactiveTabs }: Props) {
    const { website, isLoading: isLoadingSelectedWebsite, setSelectedWebsite } = useGetCurrentWebsite();
    const { data: websiteIndexEntries, isFetching: isFetchingWebsiteIndexEntries, isLoading: isLoadingWebsiteIndexEntries } = useFetchWebsiteIndexEntriesQuery();
    const { data: favicons, isLoading: isLoadingFavicons } = useFetchFaviconsQuery();
    const isLoading = isLoadingSelectedWebsite || isLoadingWebsiteIndexEntries || isLoadingFavicons;

    if (isLoading) {
        return <Spin indicator={<Icon type="loading" style={{ fontSize: 18 }} spin />} />
    }

    if (!isLoading && websiteIndexEntries?.length === 0) {
        return <NoWebsites />
    }

    return (
        <>
            {website?.guid && websiteIndexEntries && favicons && (
                <Tabs
                    className="deep-analysis-website-tabs"
                    activeKey={website.guid}
                    animated={false}
                    destroyInactiveTabPane={true}
                    onChange={setSelectedWebsite}
                    tabBarExtraContent={<AddNewWebsiteIndexEntryButton />}
                >
                    {websiteIndexEntries.map((website) => (
                        <TabPane
                            disabled={isFetchingWebsiteIndexEntries}
                            key={website.guid}
                            tab={
                                <WebsiteTab
                                    websiteGuid={website.guid}
                                    domain={website.domain}
                                    faviconUrl={favicons.filter((item) => item.guid === website.guid)[0]?.favicon_url}
                                />
                            }
                        >
                            {children}
                        </TabPane>
                    ))}
                </Tabs>)}
        </>
    );
}
